import React from "react";

/**
 * Public landing page for payment links a club sends a member (routes /pay/done and /pay/cancelled).
 * Stripe Checkout sends the member here after paying (or going back). No login needed: the purchase
 * itself is added by the Stripe webhook, not by this page.
 */

const APP_LINK = "https://onelink.to/j9byv4";

export default function PaymentReturnPage({ landFor = "done" }) {
  const done = landFor === "done";
  return (
    <main className="flex min-h-screen items-center justify-center bg-[#F7F4F8] px-4 py-10 font-[Mulish,sans-serif]">
      <div className="w-full max-w-md rounded-3xl bg-white p-7 text-center shadow-[0_20px_60px_rgba(72,27,58,0.12)] sm:p-9">
        <span className={`mx-auto flex h-16 w-16 items-center justify-center rounded-3xl ${done ? "bg-[#E8F7EE] text-[#1F6B3A]" : "bg-[#FFF4E5] text-[#7A4A00]"}`}>
          <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {done ? <path d="m5 12 5 5L20 7" /> : <><path d="M12 8v5" /><path d="M12 16h.01" /><circle cx="12" cy="12" r="9" /></>}
          </svg>
        </span>
        <h1 className="mt-5 text-2xl font-black tracking-tight text-gray-900">{done ? "Payment received" : "Payment not finished"}</h1>
        <p className="mt-2 text-[15px] text-gray-600">
          {done
            ? "Thank you! Your pass or subscription is being added to your account and shows up in the FitClub app in a minute. You'll also get a receipt by email."
            : "Nothing was charged. You can open the same link again to pay, or ask your club for a new link."}
        </p>
        <a href={APP_LINK} className="mt-6 flex h-12 items-center justify-center rounded-2xl bg-[#481B3A] text-base font-extrabold text-white hover:bg-[#5d2a4d]">
          Open the FitClub app
        </a>
        <p className="mt-4 text-xs text-gray-500">You can close this page.</p>
      </div>
    </main>
  );
}
